export default __webpack_public_path__ + "static/media/IMG_4947.916b869d.png";